import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_2 = { class: "secondary--font mt-1 text-center steps-count" }
const _hoisted_3 = { class: "text-caption secondary--font" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return ($setup.isOnboardingAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_tooltip, {
          location: "right",
          text: "Continue where you left off"
        }, {
          activator: _withCtx(({ props: tooltipProps }) => [
            _createVNode(_component_v_list_item, _mergeProps(tooltipProps, {
              density: "compact",
              link: "",
              class: "text-white onboarding-menu-item",
              "min-height": "68",
              onClick: $setup.openOnboarding
            }), {
              default: _withCtx(() => [
                ($setup.isCollapsed)
                  ? (_openBlock(), _createBlock(_component_v_list_item_title, {
                      key: 0,
                      class: "text-uppercase onboarding-item-title"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_progress_circular, _mergeProps($setup.progressCircularBind, { class: "flex-shrink-0" }), null, 16 /* FULL_PROPS */),
                        _createElementVNode("div", _hoisted_2, _toDisplayString($setup.completedStepsDisplay) + "/" + _toDisplayString($setup.totalStepsDisplay), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_v_list_item_title, {
                      key: 1,
                      class: "text-uppercase font-weight-bold onboarding-item-title-expanded"
                    }, {
                      default: _withCtx(() => [
                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-body-2 secondary--font mb-1" }, "Get Started", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_progress_circular, _mergeProps($setup.progressCircularBind, { class: "mr-2 flex-shrink-0" }), null, 16 /* FULL_PROPS */),
                          _createTextVNode(" " + _toDisplayString($setup.completedStepsDisplay) + "/" + _toDisplayString($setup.totalStepsDisplay) + " Completed ", 1 /* TEXT */)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }))
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_v_divider)
      ]))
    : _createCommentVNode("v-if", true)
}